import Link from "next/link";
import Image from "next/image";


const Logo = () => {
  return (
    <Link href="/" className="flex">
      <div className="w-[150px] h-10">
        <Image
          src="/images/logo/logoBlack.png"
          unoptimized
          alt="لوگو ژومنت"
          className="object-contain w-full h-full"
          width={150}
          height={40}
        />
      </div>
    </Link>
  );
};

export default Logo;
